(function () {
  var $ = function (id) { return document.getElementById(id); };
  var overlay, form, linesEl, totalsEl, errEl, submitEl, loadingEl;

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'LE ' + v + ' EGP';
  }
  function show(el, on) { if (el) el.hidden = !on; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* Line-item properties (e.g. a couples set's per-robe colour and size). */
  function lineProps(it) {
    var p = it && it.properties;
    if (!p) return [];
    return Object.keys(p).filter(function (k) { return k.charAt(0) !== '_' && p[k]; })
      .map(function (k) { return { key: k, value: String(p[k]) }; });
  }

  function propsHtml(it) {
    var rows = lineProps(it);
    if (!rows.length) return '';
    return '<div class="ss-line-v" style="margin-top:3px">' + rows.map(function (r) {
      return esc(r.key) + ': ' + esc(r.value);
    }).join('<br>') + '</div>';
  }

  function renderCart(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      linesEl.innerHTML = '<p style="padding:14px 0;color:#8A8085">لا توجد منتجات في السلة.</p>';
      totalsEl.innerHTML = '';
      return;
    }
    linesEl.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2')) + '" alt="" loading="lazy">' : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title')
        ? '<div class="ss-line-v">' + esc(it.variant_title) + '</div>' : '';
      variant += propsHtml(it);
      return '<div class="ss-line">' +
        '<button type="button" class="ss-line-x" data-line="' + (i + 1) + '" aria-label="حذف">&times;</button>' +
        '<div class="ss-line-p">' + money(it.final_line_price) + '</div>' +
        '<div class="ss-line-txt"><div class="ss-line-t">' + esc(it.product_title) + '</div>' + variant + '</div>' +
        '<div class="ss-line-img">' + img + '<span class="ss-qty">' + it.quantity + '</span></div>' +
        '</div>';
    }).join('');

    var rows = '<div class="ss-tot"><span>Subtotal</span><span>' + money(cart.items_subtotal_price) + '</span></div>';
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      rows += '<div class="ss-tot ss-tot-discount"><span>' + esc(d.title) + '</span><span>- ' + money(d.total_allocated_amount) + '</span></div>';
    });
    rows += '<div class="ss-tot"><span>Shipping</span><span>توصيل مجاناً</span></div>';
    rows += '<div class="ss-tot ss-tot-grand"><span>Total</span><span>' + money(cart.total_price) + '</span></div>';
    totalsEl.innerHTML = rows;
  }

  function loadCart() {
    show(loadingEl, true);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { renderCart(null); })
      .then(function (c) { show(loadingEl, false); return c; });
  }

  function open(opts) {
    opts = opts || {};
    show(overlay, true);
    document.documentElement.style.overflow = 'hidden';
    show(errEl, false);
    form.hidden = false;
    submitEl.disabled = false;
    var okBox = $('ssCodSuccess');
    if (okBox) okBox.hidden = true;
    if (opts.id) {
      show(loadingEl, true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: opts.id, quantity: opts.quantity || 1 }] })
      }).then(function () { return loadCart(); })
        .catch(function () { return loadCart(); });
    } else {
      loadCart();
    }
  }

  function close() {
    show(overlay, false);
    document.documentElement.style.overflow = '';
  }

  function fail(msg) {
    errEl.textContent = msg;
    show(errEl, true);
    try { errEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
  }

  /* Backend mode: POST the order to the configured endpoint (Cloudflare Worker),
     which creates the Shopify order; then show the confirmation screen and empty the cart. */
  function placeOrder(endpoint, cart, customer) {
    var items = (cart && cart.items ? cart.items : []).map(function (it) { return { id: it.variant_id, quantity: it.quantity }; });
    if (!items.length) { submitEl.disabled = false; show(loadingEl, false); return fail('السلة فاضية.'); }
    var detail = (cart.items || []).map(function (it) {
      var rows = lineProps(it);
      if (!rows.length) return '';
      return it.product_title + ' — ' + rows.map(function (r) { return r.key + ': ' + r.value; }).join(' / ');
    }).filter(Boolean).join(' || ');
    var fullNote = [customer.note, detail].filter(Boolean).join(' || ');
    var payload = Object.assign({}, customer, { note: fullNote, items: items, total: cart.total_price, currency: cart.currency });
    return fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) {
        if (!d || d.ok !== true) throw new Error('backend');
        showSuccess(d.order || '', customer);
        return fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }).catch(function () {});
      })
      .catch(function () {
        submitEl.disabled = false; show(loadingEl, false);
        fail('حصل خطأ، من فضلك حاول مرة تانية أو كلّمنا على 01120008599.');
      });
  }

  function showSuccess(orderName, c) {
    show(loadingEl, false);
    form.hidden = true;
    var box = $('ssCodSuccess');
    box.innerHTML =
      '<div class="ss-ok-ico">&#10003;</div>' +
      '<h3 class="ss-ok-h">تم تأكيد طلبك بنجاح 🎀</h3>' +
      (orderName ? '<p class="ss-ok-n">رقم الطلب: <b>' + esc(orderName) + '</b></p>' : '') +
      '<p class="ss-ok-p">شكراً ' + esc(c.name) + '، هنتواصل معاكي على <b dir="ltr">' + esc(c.phone) + '</b> لتأكيد التفاصيل، والتوصيل خلال يومين.</p>' +
      '<button type="button" class="ss-submit" id="ssOkClose">متابعة التسوق</button>';
    box.hidden = false;
    $('ssOkClose').addEventListener('click', function () { close(); window.location.href = '/'; });
  }

  function submit(e) {
    e.preventDefault();
    show(errEl, false);
    var name = $('ssName').value.trim();
    var phone = $('ssPhone').value.trim().replace(/[^\d]/g, '');
    var gov = $('ssGov').value;
    var addr = $('ssAddr').value.trim();
    var note = $('ssNote').value.trim();
    var payEl = form.querySelector('input[name="payment"]:checked');
    var pay = payEl ? payEl.value : '';

    if (name.length < 3) return fail('من فضلك اكتب الاسم بالكامل.');
    if (!/^01[0125]\d{8}$/.test(phone)) return fail('رقم الهاتف غير صحيح — اكتب 11 رقم يبدأ بـ 010 أو 011 أو 012 أو 015.');
    if (addr.length < 6) return fail('من فضلك اكتب العنوان بالتفصيل.');

    submitEl.disabled = true;
    show(loadingEl, true);

    var attrs = {};
    attrs['الاسم'] = name;
    attrs['رقم الهاتف'] = phone;
    attrs['المحافظة'] = gov;
    attrs['العنوان'] = addr;
    attrs['طريقة الدفع'] = pay;
    attrs['التوصيل'] = 'توصيل مجاني';
    if (note) attrs['ملاحظة'] = note;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: attrs,
        note: 'طلب سريع — ' + name + ' / ' + phone + ' / ' + gov + ' / ' + addr + ' / ' + pay + (note ? ' / ' + note : '')
      })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var endpoint = (overlay.getAttribute('data-endpoint') || '').trim();
        if (endpoint) return placeOrder(endpoint, cart, { name: name, phone: phone, governorate: gov, address: addr, note: note, payment: pay });
        var parts = name.split(/\s+/);
        var q = [
          'checkout[shipping_address][first_name]=' + encodeURIComponent(parts[0] || name),
          'checkout[shipping_address][last_name]=' + encodeURIComponent(parts.slice(1).join(' ') || '-'),
          'checkout[shipping_address][address1]=' + encodeURIComponent(addr),
          'checkout[shipping_address][city]=' + encodeURIComponent(gov || ''),
          'checkout[shipping_address][province]=' + encodeURIComponent(gov || ''),
          'checkout[shipping_address][country]=Egypt',
          'checkout[shipping_address][phone]=' + encodeURIComponent(phone)
        ].join('&');
        window.location.href = '/checkout?' + q;
      })
      .catch(function () {
        submitEl.disabled = false;
        show(loadingEl, false);
        fail('حصل خطأ، من فضلك حاول مرة تانية أو كلّمنا على 01120008599.');
      });
  }

  function injectTriggers() {
    var main = document.getElementById('MainContent');
    if (!main || String(main.dataset.template || '').indexOf('product') !== 0) return;

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (f.querySelector('[data-ss-cod]')) return;
      if (f.closest('[class*="product-card"], .card-gallery, quick-add-component')) return;
      var btn = f.querySelector('.add-to-cart-button, button[type="submit"]');
      if (!btn) return;
      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'ss-cod-trigger';
      t.setAttribute('data-ss-cod', '');
      t.textContent = 'إتمام الطلب';
      btn.insertAdjacentElement('afterend', t);
    });
  }

  function init() {
    overlay = $('ssCodOverlay');
    if (!overlay) return;
    form = $('ssCodForm'); linesEl = $('ssLines'); totalsEl = $('ssTotals');
    errEl = $('ssErr'); submitEl = $('ssSubmit'); loadingEl = $('ssCodLoading');

    $('ssCodClose').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });
    form.addEventListener('submit', submit);

    linesEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.ss-line-x');
      if (!btn) return;
      show(loadingEl, true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(btn.dataset.line), quantity: 0 })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); })
        .catch(function () {})
        .then(function () { show(loadingEl, false); });
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-ss-cod]');
      if (!trigger) return;
      e.preventDefault();
      var scope = trigger.closest('product-form-component, form[action*="/cart/add"], .shopify-section') || document;
      var idInput = scope.querySelector('[name="id"]');
      var qtyInput = scope.querySelector('[name="quantity"]');
      open({
        id: trigger.getAttribute('data-ss-cod') || (idInput && idInput.value) || null,
        quantity: qtyInput && qtyInput.value ? Number(qtyInput.value) : 1
      });
    });

    injectTriggers();
    document.addEventListener('shopify:section:load', injectTriggers);
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(injectTriggers, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }

    window.SSCOD = { open: open, close: close, refresh: injectTriggers };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
